import styled from '@emotion/styled';
import getDefaultTheme from '../themes/default.js';
function isStylesObject(styles) {
    return typeof styles === 'object';
}
const getStyle = (styles, type) => isStylesObject(styles) ? styles[type] || styles.default : styles;
function isThemeFromProvider(theme) {
    return theme.type !== undefined;
}
export default function createStyledComponent(styles, component) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return styled((component || 'div')) `
    ${(props) => isThemeFromProvider(props.theme)
        ? getStyle(styles, props.theme.type)
        : // used outside of container (theme provider)
            getStyle(styles, 'default')({
                ...props,
                theme: getDefaultTheme(props.theme),
            })}
  `;
}
// TODO: memoize it?
